import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { captureException } from '@sentry/react';
import { RootState } from 'store';
import { selectAccessToken } from 'store/user/userSlice';

const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  WebApi,
  extraOptions,
) => {
  const baseUrl = process.env.REACT_APP_SADL_API_HOST;
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: async headers => {
      try {
        const token = selectAccessToken(WebApi.getState() as RootState);

        // If we have a token set in state, let's assume that we should be passing it.
        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }
      } catch (e) {
        captureException(e);
      }
      return headers;
    },
  });

  const result = await rawBaseQuery(args, WebApi, extraOptions);

  return result;
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseApi = createApi({
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}),
});
